import { TFunction } from 'react-i18next';

import { SnackbarPayload } from 'theSource/components/Snackbar';

export const getErrorSnackbar = (
  dialogZIndex: number,
  t: TFunction
): SnackbarPayload => ({
  message: t('common:nativeAuthError'),
  severity: 'error',
  position: 'aboveNativeAuthDialog',
  disableAutoHide: true,
  zIndex: dialogZIndex + 100,
});
